import { activeCheckpointId } from '../../core/checkpoints';
import { progressOf, type LevelRun } from '../../core/level-runner';

export interface TelemetryMark {
  id: string;
  /** Position along the route, 0..1, with the same level length the runner uses. */
  at: number;
  state: 'pending' | 'active';
}

export interface TelemetryModel {
  value: number;
  marks: TelemetryMark[];
}

/**
 * Route telemetry (GDD §13.3, issue #59): the progress of the runner and one mark per checkpoint at
 * x / level length, the active one being the one the core reports. Nothing is computed here on its own.
 */
export function telemetryModel(run: Pick<LevelRun, 'level' | 'core' | 'checkpoints'>): TelemetryModel {
  const { length, checkpoints } = run.level;
  if (!(length > 0)) throw new RangeError(`level ${run.level.def.id} has no length`);
  const active = activeCheckpointId(run.checkpoints);
  return {
    value: progressOf(run as LevelRun),
    marks: checkpoints.map(({ id, x }) => ({ id, at: x / length, state: id === active ? 'active' : 'pending' })),
  };
}
